define([
    './config/RouteConfig',
    'angularRouter',
    'edge/platform/widgets/carousel/module'
], (routeConfig)=> {
    return angular.module('edge.platform.segmentation.demolandingpage', ['ui.router', 'edge.platform.widgets.carousel'])
        .config(['$stateProvider', ($stateProvider)=> {
            for (const stateName in routeConfig) {
                if (routeConfig.hasOwnProperty(stateName)) {
                    $stateProvider.state(stateName, routeConfig[stateName]);
                }
            }
        }])
        .run(['$state', 'state_plugin_config', '$timeout', ($state, appConfig, $timeout)=> {
            //when app is loaded go to an initial page while we wait for any segmentation decisions to be made
            $timeout(()=> {
                //need to put inside $timeout to allow a digest cycle to run and set initial state
                const homePage = appConfig.home;
                if ($state.current.name === homePage) {
                    $state.go('loadingLandingPage', {params: $state.params});
                }
            });
        }]);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/segmentation/demolandingpage/module.js